import React from 'react'
import { usePlatform } from '../context/PlatformContext'
import { ShieldCheckIcon, XMarkIcon } from '@heroicons/react/24/solid'

function ImpersonationBanner() {
  const { isPlatformAdmin, selectedTenantId, selectedTenantName, impersonating, stopImpersonation, exitPlatformView } = usePlatform()

  // Only show when actively viewing another tenant or impersonating
  if (!isPlatformAdmin || !selectedTenantId) return null

  return (
    <div className="bg-red-600 text-white text-center py-1.5 px-4 text-sm font-semibold fixed top-0 left-0 right-0 z-[60] flex items-center justify-center gap-3">
      <ShieldCheckIcon className="w-4 h-4 flex-shrink-0" />
      <span>
        Platform Admin — Viewing <strong>{selectedTenantName || `Tenant #${selectedTenantId}`}</strong>
        {impersonating && (
          <> as <strong>{impersonating.name || impersonating.email}</strong></>
        )}
      </span>
      <div className="flex items-center gap-2 ml-2">
        {impersonating && (
          <button
            onClick={stopImpersonation}
            className="px-2 py-0.5 bg-white/20 hover:bg-white/30 rounded text-xs font-medium transition-colors"
          >
            Stop Impersonating
          </button>
        )}
        <button
          onClick={exitPlatformView}
          className="px-2 py-0.5 bg-white/20 hover:bg-white/30 rounded text-xs font-medium transition-colors flex items-center gap-1"
        >
          <XMarkIcon className="w-3 h-3" />
          Exit
        </button>
      </div>
    </div>
  )
}

export default ImpersonationBanner
